module.exports = __webpack_public_path__ + "img/19eb67279db385c13eba740356257e6a.png";